import React from 'react'
import { getLanguageFlag, getLanguageLabel } from './languages'

export const FlagIcon = ({ language, width = 28, height = 18, style, ...props }) => {
    const src = getLanguageFlag(language)
    const label = getLanguageLabel(language)

    if (!src) {
        return (
            <span
                title={label}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: width,
                    height,
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    ...style
                }}
                {...props}
            >
                {language}
            </span>
        )
    }

    return (
        <img
            src={src}
            alt={label}
            title={label}
            width={width}
            height={height}
            style={{
                display: 'inline-block',
                objectFit: 'cover',
                borderRadius: 2,
                verticalAlign: 'middle',
                boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.12)',
                ...style
            }}
            {...props}
        />
    )
}

export const LanguageLabel = ({ language, uiLanguage }) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <FlagIcon language={language} />
        <span>{getLanguageLabel(language, uiLanguage)}</span>
    </span>
)

export default FlagIcon
